import React from 'react';
import { IoMdPause } from 'react-icons/io';
import { BsThreeDots } from 'react-icons/bs';
import OfferCardStat from '../OfferStat';
import { Avatar, AvatarSizes } from 'components/Avatar';
import { MdCopyAll } from 'react-icons/md';
import { FaCirclePlay } from 'react-icons/fa6';

interface PromoterCardProps {
  handlePromoterMoreActions?: () => void;
  handlePausePromoterLink?: () => void;
}

const PromoterCard = ({
  handlePromoterMoreActions,
  handlePausePromoterLink
}: PromoterCardProps) => {
  const isPaused = false;

  const handleClick = (e) => {
    e.stopPropagation();
    handlePromoterMoreActions?.();
  };

  const handlePausePromoter = (e) => {
    e.stopPropagation();
    handlePausePromoterLink?.();
  };
  return (
    <div
      className={`border-1 border-[#EBEBEB] rounded-lg ${
        isPaused ? 'bg-[#EBEBEB]' : ''
      }`}
    >
      <div className="p-4">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center">
            <Avatar
              src="https://i.pravatar.cc/150?img=1"
              size={AvatarSizes.Md}
              className="mr-2"
            />
            <div className="font-bold text-base">John Doe</div>
          </div>
          <BsThreeDots
            className="text-[#787878]"
            size={20}
            onClick={handleClick}
          />
        </div>
        <div className="flex items-center gap-2 pt-4 pb-2">
          <div className="text-sm font-normal">🤝</div>
          <div className="text-sm font-normal text-[#202020]">
            Tier One Promotion
          </div>
        </div>
        <div className="flex items-center gap-2 pb-4">
          <div className="text-sm font-normal">🗣️</div>
          <div className="flex flex-row items-center">
            <div className="text-sm font-normal text-[#202020]">
              Promoter code:
            </div>
            <div className="text-sm font-bold text-[#3853C4]">123456</div>
            <MdCopyAll className="text-[#3853C4] ml-1" size={16} />
          </div>
        </div>
        <div className="flex flex-1 items-center h-[44px] mb-4">
          <div
            className={`text-sm items-center font-normal text-[#202020] italic flex-1 border ${
              isPaused ? 'border-[#DCDCDC]' : 'border-[#EFF2FF]'
            } rounded-tl-[100px] rounded-bl-[100px] h-[44px]`}
          >
            <div className="flex items-center ml-2 h-full">
              https://www.hawt.com/promoter/123456
            </div>
          </div>
          <div className="w-24 h-[44px]">
            <div
              className={`flex items-center justify-center ${
                isPaused ? 'bg-[#DCDCDC]' : 'bg-[#3853C4]'
              } h-[44px] border-r-1 ${
                isPaused ? 'border-[#DCDCDC]' : 'border-[#3853C4]'
              } rounded-tr-[100px] rounded-br-[100px]`}
            >
              <div
                className={`text-sm font-bold ${
                  isPaused ? 'text-[#575757]' : 'text-white'
                }`}
              >
                Copy
              </div>
              <MdCopyAll
                className={`${isPaused ? 'text-[#575757]' : 'text-white'} ml-2`}
                size={16}
              />
            </div>
          </div>
        </div>
        <div
          className={`flex items-center justify-center gap-2 border ${
            isPaused ? '' : 'border-[#EFF2FF]'
          } rounded-2xl p-2 ${isPaused ? 'bg-[#EFF2FF]' : ''}`}
          onClick={handlePausePromoter}
        >
          <div className="text-sm font-bold text-[#3853C4]">
            {isPaused ? 'Resume Promoter Link' : 'Pause Promoter Link'}
          </div>
          {!isPaused ? (
            <IoMdPause className="text-[#3853C4]" />
          ) : (
            <FaCirclePlay className="text-[#3853C4]" />
          )}
        </div>
      </div>
      <div
        className={`h-[1px] ${
          isPaused ? 'bg-[#DCDCDC]' : 'bg-[#EBEBEB]'
        } w-full`}
      />
      <div className="flex flex-row items-center justify-between p-4">
        <OfferCardStat title="Views" description="150" />
        <OfferCardStat title="Sales" description="180" />
        <OfferCardStat title="Revenue" description="$1,200" />
        <OfferCardStat title="Earnings" description="$10,000" />
      </div>
    </div>
  );
};

export default PromoterCard;
